import { viewCustomPageExperienceId } from '@atlassian/help-center-common-util/analytics/ufo/ufo';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

export const viewCustomPageExperience = new UFOExperience(viewCustomPageExperienceId, {
	type: ExperienceTypes.Load,
	performanceType: ExperiencePerformanceTypes.PageLoad,
});
